import { currencySymbol } from "@/lib/moneyHelpers";

export const regexInput = currencySymbol
  .split("")
  .map(i => {
    if (["[", "]", "\\", "^", "$", ".", "|", "?", "*", "+", "(", ")"].includes(i)) {
      return `\\${i}`;
    }
    return i;
  })
  .join("")
  .concat("(\\d*)");
